import styled from "styled-components";

import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap";

const DisplayContainer = styled(FnrHorizontalGap)`
  min-height: 28px;
  cursor: ${(p) => (p.$canOpenSacramentEditor ? "pointer" : "default")};
`;

export default DisplayContainer;